var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"header"},[_c('div',{staticClass:"header-back"},[_c('a',{staticClass:"header-back-item",attrs:{"href":"javascript:;"},on:{"click":_vm.back}},[_c('i',{staticClass:"icon iconfont icon-fanhui1 ico-back"})])]),_vm._v(" "),_c('div',{staticClass:"header-title"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f33408ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavHeader.vue
// module id = null
// module chunks = 